<template>
    <div id="app" :style="{backgroundColor:custombgcolor?custombgcolor:'transparent'}">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
    </div>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        computed: {
            ...mapState({
                showSpin: state => state.app.showSpin,
                custombgcolor: state => state.app.custombgcolor
            })
        },
        mounted(){
            // return this.$wechat.updateShareData({
            //     title: '2022年体锻达标赛',
            //     description: '2022年体锻达标赛',
            //     imageUrl:'https://oss.mcloud.moveclub.cn/alphamovecloud/20221012/1665575342/1665575347734/图层1.jpg',
            //     link:  `${window.location.origin}${window.location.pathname}`
            // })
        }
    }
</script>
<style lang="less">
    @import "./App.less";
</style>
